/** Canton `adminToolSsoEnabled` values. */
export enum AdminToolSsoMode {
  Off = 0,
  On = 1,
  SsoOnly = 2,
}

export const normalizeAdminToolSsoMode = (value: number | boolean | undefined): AdminToolSsoMode => {
  if (value === undefined) {
    return AdminToolSsoMode.Off;
  }
  if (value === true) {
    return AdminToolSsoMode.On;
  }
  if (value === false || value === AdminToolSsoMode.Off) {
    return AdminToolSsoMode.Off;
  }
  if (value === AdminToolSsoMode.SsoOnly) {
    return AdminToolSsoMode.SsoOnly;
  }

  return AdminToolSsoMode.On;
};

export const isAdminToolSsoAvailable = (mode: AdminToolSsoMode): boolean =>
  mode === AdminToolSsoMode.On || mode === AdminToolSsoMode.SsoOnly;

export const isAdminToolSsoOnly = (mode: AdminToolSsoMode): boolean => mode === AdminToolSsoMode.SsoOnly;
